import { useState } from "react";
import "./BankDetailsStep.css";

function BankDetailsStep({
  providerData,
  setProviderData,
  nextStep,
  previousStep,
}) {

  const [errors, setErrors] = useState({});

  const bank = providerData.bank || {};

  const handleChange = (e) => {

    const { name, value } = e.target;

    setProviderData({

      ...providerData,

      bank: {

        ...bank,

        [name]: value,

      },

    });

  };

  const validate = () => {

    let newErrors = {};

   if (!(bank.accountHolder || "").trim()) {
  newErrors.accountHolder = "Account Holder Name is required";
}

if (!(bank.bankName || "").trim()) {
  newErrors.bankName = "Bank Name is required";
}

if (!(bank.accountNumber || "").trim()) {
  newErrors.accountNumber = "Account Number is required";
}

if (bank.accountNumber !== bank.confirmAccountNumber) {
  newErrors.confirmAccountNumber = "Account Numbers do not match";
}

if (!(bank.ifscCode || "").trim()) {
  newErrors.ifscCode = "IFSC Code is required";
}
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;

  };
  const verifyBank = () => {

    if (!validate()) return;

    setProviderData({

        ...providerData,

        bank: {

            ...bank,

            isVerified: true,

        },

    });

    alert("Bank account verified successfully.");

};

  const handleContinue = () => {

    if (!validate()) return;

    if (!bank.isVerified) {

        alert("Please verify your bank account before continuing.");

        return;

    }

    nextStep();

};
  return (

    <div className="bank-step">

      <h2>Bank Details</h2>

      <p>

        Enter your bank account for future payouts.

      </p>

      <input
        type="text"
        name="accountHolder"
        placeholder="Account Holder Name"
        value={bank.accountHolder || ""}
        onChange={handleChange}
      />

      <span>{errors.accountHolder}</span>

      <input
        type="text"
        name="bankName"
        placeholder="Bank Name"
        value={bank.bankName || ""}
        onChange={handleChange}
      />

      <span>{errors.bankName}</span>

      <input
        type="text"
        name="accountNumber"
        placeholder="Account Number"
        value={bank.accountNumber || ""}
        onChange={handleChange}
      />

      <span>{errors.accountNumber}</span>

      <input
        type="text"
        name="confirmAccountNumber"
        placeholder="Confirm Account Number"
        value={bank.confirmAccountNumber || ""}
        onChange={handleChange}
      />

      <span>{errors.confirmAccountNumber}</span>

      <input
        type="text"
        name="ifscCode"
        placeholder="IFSC Code"
        value={bank.ifscCode || ""}
        onChange={handleChange}
      />

      <span>{errors.ifscCode}</span>
      <button
    type="button"
    className="verify-btn"
    onClick={verifyBank}
>
    Verify Bank Account
</button>

{bank.isVerified ? (

    <p className="verified">
        ✅ Bank Account Verified
    </p>

) : (

    <p className="not-verified">
        ❌ Not Verified
    </p>

)}

      <input
        type="text"
        name="upiId"
        placeholder="UPI ID (Optional)"
        value={bank.upiId || ""}
        onChange={handleChange}
      />

      <label>Account Type</label>

      <select
        name="accountType"
        value={bank.accountType || "Savings"}
        onChange={handleChange}
      >

        <option value="Savings">Savings</option>

        <option value="Current">Current</option>

      </select>

      <div className="step-buttons">

        <button onClick={previousStep}>

          ← Back

        </button>

        <button onClick={handleContinue}>

          Continue →

        </button>

      </div>

    </div>

  );

}

export default BankDetailsStep;